module.exports = __webpack_public_path__ + "static/media/eye.f09baed0.svg";